@import '~style-sheet-helpers/core.less';

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.is-loading-rate {
  animation: spin 1350ms linear infinite;
}
